export default __webpack_public_path__ + "static/media/img-consumer-wallet-new.0814981c.jpg";